export const ICON_CYCLER_TEST_ID_SUFFIX = 'icon-cycler';
